import dynamic from "next/dynamic"
import "react-quill/dist/quill.snow.css"

import { ReactQuillProps } from "react-quill"

import { create } from "src/helpers/bem"

import { defaultFormats, defaultModules } from "./defaultConfig"
import styles from "./Editor.module.scss"

const bem = create(styles, "Editor")

// Import react-quill dynamically to avoid SSR issues
// See: https://medium.com/@jamshaidmehmood1234/integrating-react-quill-in-a-next-js-application-with-typescript-46851c2c07df
const ReactQuill = dynamic(() => import("react-quill"), { ssr: false })

type RichTextEditorProps = ReactQuillProps

export const RichTextEditor = ({
  formats = defaultFormats,
  modules = defaultModules,
  ...other
}: RichTextEditorProps) => {
  return (
    <ReactQuill
      {...other}
      className={bem()}
      formats={formats}
      modules={modules}
      theme="snow"
    />
  )
}

export default RichTextEditor
